import api from '@/utils/axiosInstance';

export const getMenus = async (sessionId?: string | null) => {
  const { data } = await api.get('/menu', { params: { sessionId } });
  return data.data;
};
